import { useState, useEffect } from "react";

const FontSelector = ({
  title,
  selectedFont,
  tempFontColor,
  onApply,
  label,
  buttonColor,
  buttonTextColor,
}) => {
  const [localColor, setLocalColor] = useState(tempFontColor);
  const [localFont, setLocalFont] = useState(selectedFont);

  useEffect(() => {
    setLocalColor(tempFontColor);
  }, [tempFontColor]);

  useEffect(() => {
    setLocalFont(selectedFont);
  }, [selectedFont]);

  const handleApply = () => {
    // Call onApply with both font and color
    onApply(localFont, localColor);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
        padding: "15px",
        background: "#2a2a3e",
        borderRadius: "10px",
        width: "200px",
        minHeight: "200px",
      }}
    >
      {/* Font selector block */}
      <div style={{ color: "#ccc", fontWeight: "600", fontSize: "14px" }}>
        {title}
      </div>
      <select
        value={localFont}
        onChange={(e) => setLocalFont(e.target.value)}
        style={{
          background: "#1a1a2e",
          color: "#fff",
          border: "2px solid #00B5AD",
          padding: "6px",
          borderRadius: "6px",
          width: "160px",
          textAlign: "center",
        }}
      >
        <option value="'Horizon', sans-serif">Horizon</option>
        <option value="'Arial Black', sans-serif">Arial Black</option>
        <option value="Impact, 'Arial Black', sans-serif">Impact</option>
        <option value="Verdana, sans-serif">Verdana</option>
        <option value="'Courier New', monospace">Courier New</option>
        <option value="'Jupiter Brush', cursive">Jupiter Brush</option>
        <option value="'Microgramma', sans-serif">Microgramma</option>
      </select>

      <div
        style={{
          width: "100%",
          height: "25px",
          border: "2px solid #444",
          overflow: "hidden",
          cursor: "pointer",
        }}
      >
        <input
          type="color"
          value={localColor}
          onChange={(e) => setLocalColor(e.target.value)}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            cursor: "pointer",
            transform: "scale(1.5)", // Makes color selection easier
          }}
          title={`Select ${label.toLowerCase()}`}
        />
      </div>

      <div
        style={{
          fontSize: "12px",
          color: "#888",
          fontFamily: "monospace",
          background: "#1a1a2e",
          padding: "4px 8px",
          borderRadius: "4px",
          minWidth: "100px",
          textAlign: "center",
        }}
      >
        {localColor.toUpperCase()}
      </div>
      <button
        onClick={handleApply}
        style={{
          padding: "6px 12px",
          background: buttonColor || "#00B5AD",
          color: buttonTextColor || "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
        }}
      >
        Apply
      </button>
    </div>
  );
};

export default FontSelector;
